import { render, staticRenderFns } from "./FullBanner.vue?vue&type=template&id=51011af0&"
import script from "./FullBanner.vue?vue&type=script&lang=js&"
export * from "./FullBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports